module.exports = __webpack_public_path__ + "img/menu-picture.fe89acaf.png";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":512,"height":641,"variants":[{"file":"img/menu-picture-480w.4f76fa4fdcd5.webp","width":480},{"file":"img/menu-picture-512w.c7e13c62f3b2.webp","width":512}]};
}